import React from 'react';
import styled from 'styled-components/macro';
import { Menu as AntdMenu } from 'antd';
import { useSidebar } from './context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Logo from '../../assets/images/logo-white.svg';

const { Item } = AntdMenu;

const Container = styled(Item)<{ collapsed: boolean }>`
  ${({ collapsed }) =>
    collapsed &&
    `img {
    opacity: 0 !important;
    max-width: 0;
  }`}
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: transparent !important;
  cursor: initial;
  position: relative;
  margin: 8px 0 24px 0 !important;
  img {
    transition: opacity 0.3s;
    opacity: 1;
    height: 35px;
    margin-right: 21px !important;
  }
  user-select: none;
  background: transparent;
  padding: 8px !important;
  svg {
    font-size: 21px;
    min-width: 21px;
    margin-left: 15.5px;
    cursor: pointer;
    vertical-align: 0;
  }
`;

const Burger: React.FC = (props) => {
  const { collapsed, setCollapsed } = useSidebar();
  return (
    <Container title="" {...props} collapsed={collapsed}>
      <FontAwesomeIcon
        onClick={() => setCollapsed(!collapsed)}
        icon={['fas', 'bars']}
        color="white"
      />
      <img src={Logo} />
    </Container>
  );
};

export default Burger;
